import * as React from "react"
import FailX from "./FailX"
import SearchSVG from "../../images/search.svg"
import XSVG from "../../images/x.svg"

const SearchBox = ({
	numberOfGuessesOrStatic,
	query,
	response,
	setResponse,
	submitAnswer,
	wrong,
	giveUp,
	tester,
}) => (
	<div
		style={{
			display: "flex",
			height: "40px",
			lineHeight: "40px",
			marginTop: "var(--half)",
			marginLeft: "var(--single)",
			position: "relative",
		}}>
		<FailX giveUp={giveUp} wrong={wrong} />
		<img
			alt="Submit"
			className="hideOnMobile"
			disabled={wrong === numberOfGuessesOrStatic}
			src={SearchSVG}
			style={{
				display: "inline-block",
				width: "20px",
				marginRight: "var(--half)",
			}}
		/>
		<div id="query" style={{ marginRight: "0.25em", whiteSpace: "nowrap" }}>
			{query}
		</div>
		<input
			disabled={wrong === numberOfGuessesOrStatic}
			id="mainInput"
			maxLength="40"
			onChange={(event) => setResponse(event.target.value)}
			onKeyDown={submitAnswer}
			spellCheck="true"
			type="text"
			value={response}
			style={{ overflow: "hidden", fontWeight: tester ? "normal" : "initial" }}
		/>
		{response.length > 0 && (
			<img
				alt="Clear"
				src={XSVG}
				onClick={() => setResponse("")}
				onKeyDown={(event) => event.key === "Enter" && setResponse("")}
				style={{
					display: "inline-block",
					width: "30px",
					margin: "0 15px",
					cursor: "pointer",
				}}
			/>
		)}
	</div>
)
export default SearchBox
